import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
/**
 * In the phone drawer, the header dropdowns (Messages, Notifications,
 * fof/drafts' Drafts) go to their page instead of opening. The same tap
 * also opened the dropdown: Bootstrap toggles it from a listener on the
 * document, and only a later tap elsewhere closes it. On iOS that never
 * came, so the empty sheet ("No new messages") was still open the next
 * time the drawer opened.
 */
export default function drawerDropdowns() {
  // Going to the page from the drawer: the tap stops at the button, before
  // Bootstrap's toggle.
  override('flarum/forum/components/HeaderDropdown', 'onclick', function (original, e) {
    const fromDrawer = app.drawer.isOpen();
    original(e);
    if (fromDrawer) e?.stopPropagation();
  });

  // And should one still be open, opening the drawer closes it.
  extend('flarum/common/utils/Drawer', 'show', () => {
    // @ts-ignore - Bootstrap's dropdown plugin has no types (as in core).
    $('.App-drawer .Dropdown.open > .Dropdown-toggle').dropdown('toggle');
  });
}